import { Component, OnInit, Inject, AfterViewInit, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { TabService } from 'src/app/services/tab/tab.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from 'src/app/services/auth/auth.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { ManutencaoVestaSugestoesService } from 'src/app/services/manutencao-vesta-sugestoes/manutencao-vesta-sugestoes.service';
import { HeaderComponent } from '../header.component';
import { StorageService } from 'src/app/services/storage/storage.service';
import { ModalAlertaComponent } from '../modal-alerta/modal-alerta.component';
import { UsuarioListRequest, UsuarioService } from 'src/app/services/usuario/usuario.service';

@Component({
  selector: 'app-modal-sugestoes',
  templateUrl: './modal-sugestoes.component.html',
  styleUrls: ['./modal-sugestoes.component.scss'],
  providers: [TabService]
})
export class ModalSugestoesComponent implements OnInit, AfterViewInit {
  codigoMDT: number;
  public req: UsuarioListRequest = new UsuarioListRequest();
  isLoading = true;
  isLoadingSugestao = false;
  sugestoesTotais;
  disableButton: boolean = false;

  userEmail = StorageService.getPerfilUsuario();

  nome: string;
  email: string;
  emailResposta: string;
  senha: string;
  repetirSenha: string;
  alterarsenha: boolean = false;

  formSugestao: FormGroup = new FormGroup({
    // email: new FormControl(this.userEmail.email, [Validators.required]),
    assunto: new FormControl("", Validators.required),
    descricao: new FormControl("", Validators.required),
  });


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalSugestoesComponent>,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private authService: AuthService,
    private usuarioService: UsuarioService,
    public serviceSugestoes: ManutencaoVestaSugestoesService,
  ) {
    this.nome = this.data.usuario.nome,
    this.email = this.data.usuario.email === undefined ? '' : this.data.usuario.email
  }

  ngOnInit() { 
  }

  ngAfterViewInit() {
  }

  public validarEmail(email: string): boolean {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  }


  public enviarSugestao() {
    this.req = {
      paginaAtual:  1,
      itensPorPagina: 10,
      usuario: this.userEmail.username,
      nome: this.userEmail.nome
    };
    this.usuarioService
      .getUserProfileList(this.req)
      .subscribe(
        (response: any) => {
          this.emailResposta = response[0].eMail;
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.openSnackBar(
            "Ocorreu um erro ao enviar sua sugestão.",
            "OK",
            3000,
            "danger-snackbar"
          );
        }
      )
      .add(() => {
        this.isLoading = false;
      });
    this.isLoading = true;
    setTimeout(() => {
      if (!this.validarEmail(this.emailResposta )|| this.emailResposta === 'ab@ab.com') {
        const dialogRef = this.dialog.open(ModalAlertaComponent, {
          width: '540px',
          data: {
            texto: `Usuário com email inválido ou inexistente. Para enviar sugestões, entre em contato com o suporte para atualização do cadastro.`
          },
        });
        dialogRef.afterClosed().subscribe(
          async response => {
            if (response == '' || !response || response == 'cancel') {
              this.dialogRef.close();
            }
          });
        this.disableButton = true;
      } else {
        const obj = { sugestaoStatus: 1, dtPublicacao: new Date() };
        for (const field in this.formSugestao.controls) {
          obj[field] = this.getValue(field);
        }
        this.serviceSugestoes
          .cadastrar(obj)
          .subscribe(
            (response: any) => {
              if (!response.body.teveSucesso) {
                return this.openSnackBar(
                  response.body.mensagem,
                  "OK",
                  3000,
                  "warning-snackbar"
                );
              } else {
                this.openSnackBar(
                  "Sua sugestão foi enviada com sucesso!",
                  "OK",
                  3000,
                  "success-snackbar"
                );
                this.responderSugestao();
                this.dialogRef.close('OK');
              }
            },
            (err: HttpErrorResponse) => {
              console.error(err);
              this.openSnackBar(
                "Ocorreu um erro ao enviar sua sugestão.",
                "OK",
                3000,
                "danger-snackbar"
              );
            }
          )
          .add(() => {
            this.isLoading = false;
          });
      }      
    }, 200);
  }

  public responderSugestao() {
    const dataAtual = new Date();
    const obj = {
      resposta: null,
      sugestaoId: 0,
      usuario: null,
      dtInclusao: dataAtual,
      destinatario: this.userEmail.email,
    };
    this.serviceSugestoes
      .responderSugestao(obj)
      .subscribe(
        (response: any) => { },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.isLoading = false;
          this.openSnackBar(
            `Erro ao responder sugestão.`,
            "OK",
            5000,
            "danger-snackbar"
          );
        }
      )
      .add(() => (this.isLoading = false));
  }


  public getValue(propName) {
    return this.formSugestao.get(propName)?.value;
  }

  submit() {
    if (!this.validarSenha()) {
      this.openSnackBar('Preencha a senha corretamente!', 'OK', 3000, 'danger-snackbar');
      return;
    }

    if (this.nome !== '' && this.email !== '') {
      var obj = {
        nome: this.nome,
        usuario: this.nome,
        email: this.email,
        password: this.senha
      };

      this.authService.alterarDados(obj).subscribe(
        response => {
          this.openSnackBar('Dados alterados com sucesso!', 'OK', 3000, '');
          const salt = btoa('sequoia');
          localStorage.setItem(btoa('nome'), `${btoa(this.nome)}${salt}`);
          localStorage.setItem(btoa('email'), `${btoa(this.email)}${salt}`);
        },
        error => {

        });
    }
  }

  validarSenha() {
    if (this.alterarsenha) {
      if (this.senha === undefined || this.senha === '' || this.repetirSenha === undefined || this.repetirSenha === '' || this.senha.length < 6 || this.repetirSenha.length < 6)
        return false;
      else if (this.senha !== this.repetirSenha)
        return false;
      else
        return true;
    }
    return true;
  }

  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }
}
